"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      color: function color(props) {
        return props.color ? props.color : theme.palette.common.white;
      },
      fontSize: 24,
      marginBottom: theme.spacing(5)
    }
  };
});

var StatCardHeader = function StatCardHeader(_ref) {
  var color = _ref.color,
      children = _ref.children;
  var classes = useStyles({
    color: color
  });
  return /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.root,
    variant: "h4",
    align: "center"
  }, children);
};

var _default = StatCardHeader;
exports.default = _default;